__turbopack_context__.v({
  "container": "_0EhJna_container",
  "group": "_0EhJna_group",
  "groupLabel": "_0EhJna_groupLabel",
  "option": "_0EhJna_option",
});
